export { default } from "./SimpleDataTable";
